import React from 'react'
import DocsLink from '../../../common/custom/DocsLink'

const StripeConnect = () => {
  return (
    <>
      <h5>
        <b>Stripe Connect</b>
      </h5>
      <p>
        The Stripe Connect plugin lets you easily integrate Stripe Connect to accept payments
        online.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/stripe-direct-charge" />
      <br />
      <h5>
        <b>Stripe - Destination Charge</b>
      </h5>
      <p>
        The Destination Charge allows users to make payments directly to the connected Stripe
        account.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/destination-charge-in-stripe" />
      <br />
      <h5>
        <b>Stripe - Separate Charge</b>
      </h5>
      <p>
        The Separate Charge allows users to make payments to multiple connected accounts where the
        amount gets tranferred separately.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/destination-charge-in-stripe" />
    </>
  );
}

export default StripeConnect